import {LOGIN_USER_REQUEST_SUCCESS, LOGOUT} from "../user/reducer";

export default (state = {}, action) => {
    switch (action.type){
        case LOGIN_USER_REQUEST_SUCCESS:
            return Object.assign({}, state, action.payload);
        case LOGOUT:
            return Object.assign({}, state, {
                token: null
            });
        default:
            return state;
    }
}